export enum MotivationTypes {
  child_interest = 'child_interest',
  prof_development = 'prof_development',
  educational_interest = 'educational_interest',
  mental_health = 'mental_health',
  assignment = 'assignment',
  personal_interest = 'personal_interest',
  other = 'other'
}
